import { render, staticRenderFns } from "./productTable.vue?vue&type=template&id=23c3ce94&scoped=true&"
import script from "./productTable.vue?vue&type=script&lang=js&"
export * from "./productTable.vue?vue&type=script&lang=js&"
import style0 from "./productTable.vue?vue&type=style&index=0&id=23c3ce94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c3ce94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23c3ce94')) {
      api.createRecord('23c3ce94', component.options)
    } else {
      api.reload('23c3ce94', component.options)
    }
    module.hot.accept("./productTable.vue?vue&type=template&id=23c3ce94&scoped=true&", function () {
      api.rerender('23c3ce94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/delivery_permission_configuration/components/productTable.vue"
export default component.exports